
export class dataProcessCancel {
    examId:number;
    requestId:number;
    protocol:string;
    
    constructor() {
    }
}